import React from 'react';
import { FormattedMessage } from 'react-intl';
import CartEmptyWrapper from './CartEmptyWrapper';
import CartToolbar from './CartToolbar';
import CartSupport from './CartSupport';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

function CartLoggedOut() {
    function showAuthModal(e, action) {
        e.preventDefault();
        authModalLoader.show({
            action,
            ga: { label: 'cart link' },
        });
    }

    return (
        <React.Fragment>
            <CartToolbar />
            <CartEmptyWrapper>
                <div data-tn="cart-logged-out-message">
                    <a href="#login" onClick={e => showAuthModal(e, 'login')}>
                        <FormattedMessage id="CartEmpty.loggedOut.logIn" defaultMessage="Log in" />
                    </a>{' '}
                    <FormattedMessage id="CartEmpty.loggedOut.or" defaultMessage="or" />{' '}
                    <a href="#register" onClick={e => showAuthModal(e, 'register')}>
                        <FormattedMessage
                            id="CartEmpty.loggedOut.register"
                            defaultMessage="register"
                        />
                    </a>{' '}
                    <FormattedMessage
                        id="CartEmpty.loggedOut.toView"
                        defaultMessage="to view your cart"
                    />
                </div>
            </CartEmptyWrapper>
            <CartSupport />
        </React.Fragment>
    );
}

export default CartLoggedOut;
